/**
 * Д-17: плашка «вышло обновление — обновите страницу».
 *
 * Обёртка над чистым сторожем `utils/updateWatch.js`: тот сравнивает хеш
 * бандла вкладки с хешем из свежего index.html, а здесь — только показ и
 * кнопка. Плашка стоит в двух каркасах: у кабинета (CabinetShell, над
 * содержимым любой страницы) и у участника (`/j/chat`, в шапке карточки).
 *
 * 🔴 Без автоперезагрузки и без крестика. Перезагрузка стирает набранный
 * текст и незавершённую отправку — решать человеку, поэтому кнопка. А
 * закрыть плашку нельзя намеренно: старый бандл ЛОМАЕТ приём новых
 * сообщений (вложение придёт голым текстом навсегда, находка окна 15.09),
 * это не уведомление «на потом». Строка стоит ~40px и не прокручивается с
 * лентой — предупреждение, которого не видно, равно отсутствующему (тот же
 * урок, что у закреплённых строк доверия в pinnedWarnings.jsx).
 *
 * 🔴 Живая область (`role="status"`) СМОНТИРОВАНА ВСЕГДА и наполняется при
 * находке: диктор надёжно озвучивает только изменения ВНУТРИ уже
 * существующей области, а вставленный сразу заполненным блок может пройти
 * молча (ревью с.89, Low). Пустая область места не занимает
 * (`.msgUpdateBar:empty` в css).
 *
 * Компонент общий для кабинета и публичной страницы и намеренно чистый: без
 * роутера, без axios ЛК — иначе он потянул бы каркас кабинета в `/j/chat`.
 */
import React, { useEffect, useState } from 'react';
import { getUpdateState, startUpdateWatch, subscribeUpdate } from '../utils/updateWatch';
import './updateBanner.css';

export const UPDATE_TEXT = 'Вышло обновление чата. Обновите страницу — иначе новые сообщения могут прийти неполными.';
export const UPDATE_BUTTON = 'Обновить страницу';

/** true, когда web-контейнер отдаёт другой бандл, чем тот, что выполняется здесь. */
export function useUpdateAvailable() {
  const [available, setAvailable] = useState(() => getUpdateState().updateAvailable);
  useEffect(() => {
    const stop = startUpdateWatch();
    const unsubscribe = subscribeUpdate((s) => setAvailable(s.updateAvailable));
    setAvailable(getUpdateState().updateAvailable); // могло смениться до подписки
    return () => { unsubscribe(); stop(); };
  }, []);
  return available;
}

const defaultReload = () => window.location.reload();

export default function UpdateBanner({ reload = defaultReload }) {
  const available = useUpdateAvailable();
  return (
    // aria-live, а не role="status": то же вежливое озвучивание изменений, но
    // пустая область не отвечает на запрос роли «status» по всей странице
    // (у «Мой QR» своя строка role="status" — тесты и диктор путали бы их)
    <div
      className="msgUpdateBar"
      aria-live="polite"
      aria-atomic="true"
      data-testid="update-banner"
      data-available={available ? 'true' : 'false'}
    >
      {available && (
        <>
          <span>{UPDATE_TEXT}</span>
          <button type="button" onClick={reload} data-testid="update-banner-reload">
            {UPDATE_BUTTON}
          </button>
        </>
      )}
    </div>
  );
}
